import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  getState: () => axios.get(`${API}/state`).then((r) => r.data),
  listSprints: () => axios.get(`${API}/sprints`).then((r) => r.data),
  calculate: (landed_money, opts = {}) =>
    axios.post(`${API}/sprint/calculate`, { landed_money, ...opts }).then((r) => r.data),
  accept: (id) => axios.post(`${API}/sprint/${id}/accept`).then((r) => r.data),
  protect: (id) => axios.post(`${API}/sprint/${id}/protect`).then((r) => r.data),
  confirm: (id, payments) =>
    axios.post(`${API}/sprint/${id}/confirm`, { payments }).then((r) => r.data),
  saveFoundation: (payload) => axios.post(`${API}/foundation`, payload).then((r) => r.data),
  reset: () => axios.post(`${API}/reset`).then((r) => r.data),
};
